import { KeyFeatureSection } from './view';

export default KeyFeatureSection;
